/** Модель подтаблицы — для подписи модалки и слияния со схемой API */
export default {
  description: "Позиция акта списания",
};
